import SpinnerModal from './SpinnerModal';

export default SpinnerModal ;